import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import {getPriceList} from '../actions/price_list';
import Select from 'react-select';
const PriceList: React.FC = (props: any) => {
  console.log(props);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [selectedSymbol, setSelectedSymbol] = useState<string | null>(null);
    
    const filteredData = selectedSymbol
    ? props.prices.filter((item: any) => item.symbol === selectedSymbol)
    : props.prices;

    const customStyles = {
      control: (provided: any) => ({
        ...provided,
        textAlign: 'left',
      }),
      singleValue: (provided: any) => ({
        ...provided,
        textAlign: 'left',
      }),
      menu: (provided: any) => ({
        ...provided,
        textAlign: 'left',
      }),
      option: (provided: any) => ({
        ...provided,
        textAlign: 'left',
      }),
    };

    useEffect(() => {
     props.dispatch(getPriceList());
    }, []);
    return (
      <div className='container-fluid'>
      <div className="p-6">
      <h2 className="text-2xl font-semibold mb-4">📈 Price List</h2>

      {props.loading && <div className="text-gray-500">Loading prices...</div>}
      {error && <div className="text-red-600">{error}</div>}

      {!props.loading && !error && (
        <div className="overflow-x-auto">
          <div className="row">
            <div className='col-12 col-md-12 col-lg-12'>
            <div className="mb-4 w-full">
              <Select
                id="symbolSelect"
                options={props.prices.map((item: any) => ({
                  value: item.symbol,
                  label: item.symbol,
                }))}
                onChange={(selected: any) => setSelectedSymbol(selected ? selected.value : null)}
                placeholder="Choose a symbol..."
                isClearable
                styles={customStyles}
              />
            </div>
            </div>
          </div> 
          
          <table className="table table-hover">
            <thead className="bg-gray-100 text-gray-700 uppercase">
              <tr>
                <th className="px-4 py-2 border">Symbol</th>
                <th className="px-4 py-2 border">Date</th>
                <th className="px-4 py-2 border">Price</th>
              </tr>
            </thead>
            <tbody>
              {filteredData && filteredData.map((item: any, index: number) => (
                <tr key={index} className="hover:bg-gray-50">
                  <td className="px-4 py-2 border">
                      <div className='ms-auto'>
                        <div className='mb-1 text-start'><Link title={`Xem chi tiết mã ${item.symbol}`} to={{pathname: `/symbol/${item.symbol}`}}>{item.symbol}
                        </Link>
                        </div>
                        <div className="text-start">{item.name}</div>
                    </div>
                    </td>
                  <td className="px-4 py-2 border">{item.date}</td>
                  <td className="px-4 py-2 border">{item.price}</td>
                </tr>
              ))}
            </tbody>
          </table>
          
        </div>
      )}
    </div>
    </div>
    );
}
const mapStateToProps = (state: any) => {
    console.log('PriceList: ',state)
    return {
      prices: state.priceList.prices,
      loading: state.priceList.loading,
    }
  };

export default connect(mapStateToProps)(PriceList);